import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, Outlet } from 'react-router-dom';
import { isDevAuthBypassEnabled } from '@/app/devMode';
import { AppShellSkeleton } from '@/layouts/MainLayout/AppShellSkeleton';

export function ProtectedLayout() {
  const { isAuthenticated, isLoading } = useAuth0();
  const effectiveIsAuthenticated = isAuthenticated || isDevAuthBypassEnabled;

  if (isLoading && !isDevAuthBypassEnabled) {
    return <AppShellSkeleton />;
  }

  if (!effectiveIsAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Render child routes via Outlet
  return <Outlet />;
}
